<template>
  <div class="container">
    <BlockUI :message="msg" v-show="this.loading > 0">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <div class="ui grid">
      <h1>{{ heading }} User Details</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form segment" @submit.prevent="userDetailsUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Companies</label>
            <div
              class="ui fluid multiple search selection dropdown"
              id="companiesSelect"
            >
              <input
                type="hidden"
                name="state"
                v-model="companies"
                id="companies"
              />
              <div class="default text">Companies</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="company in companyList"
                  :key="company.value"
                  v-bind:data-value="company.value"
                >
                  {{ company.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="eight wide column">
            <label for="userType">User Type</label>
            <div
              class="ui fluid multiple selection dropdown"
              id="userTypeSelect"
            >
              <input
                type="hidden"
                name="userType"
                v-model="roles"
                id="userType"
              />
              <div class="default text">User Type</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="userType in userTypes"
                  :key="userType.value"
                  v-bind:data-value="userType.value"
                >
                  {{ userType.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              v-model="firstName"
              class="field"
            />
          </div>

          <div class="eight wide column">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              v-model="lastName"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Title</label>
            <input
              type="text"
              name="title"
              placeholder="title"
              v-model="title"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="email"
              v-model="email"
              class="field"
            />
          </div>

          <div class="eight wide column">
            <label>Phone Number</label>
            <input
              type="tel"
              name="Phone"
              placeholder="(000) 000-0000"
              v-mask="'(###) ###-####'"
              v-model="phone"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address Name</label>
            <input
              type="text"
              name="addressName"
              v-model="address.name"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address</label>
            <input
              type="text"
              name="address"
              v-model="address.street"
              class="field"
            />
          </div>

          <div class="eight wide column">
            <label>Address Line 2</label>
            <input
              type="text"
              name="address2"
              v-model="address.street2"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address Line 3</label>
            <input
              type="text"
              name="address2"
              v-model="address.street3"
              class="field"
            />
          </div>
        </div>

        <div class="row">
          <div class="four wide column">
            <label>City</label>
            <input
              type="text"
              name="city"
              v-model="address.city"
              class="field"
            />
          </div>

          <div class="four wide column">
            <label>State</label>
            <div id="stateSelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="state"
                v-model="address.state"
                id="state"
                @change="onStateChange"
              />
              <div class="default text">Select State</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="state in states"
                  :key="state.value"
                  v-bind:data-value="state.value"
                >
                  {{ state.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="four wide column">
            <label>Postal Code</label>
            <input
              type="text"
              name="postalCode"
              v-model="address.postalCode"
              class="field"
            />
          </div>
          <div class="four wide column">
            <label>Country</label>
            <div id="countrySelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="country"
                v-model="address.country"
                id="country"
                @change="onCountryChange"
              />
              <div class="default text">Select Country</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="country in countries"
                  :key="country.value"
                  v-bind:data-value="country.value"
                >
                  <i :class="country.flag" class="flag"></i>{{ country.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                class
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="pending" class="toggle label">Pending</label>
            <div class="ui toggle checkbox">
              <input
                id="pending"
                name="pending"
                type="checkbox"
                tabindex="0"
                class
                v-model="pending"
              />
              <label for="pending">Approved</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{ button }} User</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import "expose-loader?$!expose-loader?jQuery!jquery";
import { mapGetters } from "vuex";

export default {
  name: "UserDetails",
  computed: {
    ...mapGetters({ loading: "loading" })
  },
  components: {},
  mounted() {
    this.getCompanies();
    this.getUserTypes();

    if (this.$route.params.id == undefined) {
      this.address.country = "US";
      this.button = "Add";
      this.heading = "Add";
    } else {
      this.userDetails();
      this.button = "Save";
      this.heading = "Edit";
    }
  },
  data() {
    return {
      companies: [],
      companyList: [],
      id: "",
      customerId: "",
      firstName: "",
      lastName: "",
      title: "",
      email: "",
      phone: "",
      dateRegistered: "",
      active: "",
      pending: "",
      roles: [],
      userTypes: [],
      address: [],
      states: [],
      countries: [],
      showModal: false,
      error: false,
      button: "",
      heading: "",
      msg: "Loading . . .",
    };
  },
  methods: {
    userDetails() {
      let _this = this;
      apiService
        .getUser({ id: this.$route.params.id })
        .then((request) => {
          this.userDetailsSuccessful(request);
        })
        .then(() => {
          _this.getStates(_this.address.country);
        })
        .catch((err) => this.userDetailsFailed(err));
    },
    userDetailsSuccessful(request) {
      (this.companies = request.companies),
        (this.id = request.id),
        (this.customerId = request.customerId),
        (this.firstName = request.firstName),
        (this.lastName = request.lastName),
        (this.title = request.title),
        (this.email = request.email),
        (this.phone = request.phone),
        (this.dateRegistered = request.dateRegistered),
        (this.active = request.active),
        (this.pending = request.pending),
        (this.roles = request.roles),
        (this.address = request.address);
      $("#companiesSelect").dropdown("set selected", request.companies);
      $("#userTypeSelect").dropdown("set selected", request.roles);
      this.getCountries();
    },
    userDetailsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    userDetailsUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createUser({
            companies: this.companies,
            id: this.id,
            customerId: this.customerId,
            firstName: this.firstName,
            lastName: this.lastName,
            title: this.title,
            email: this.email,
            phone: this.phone,
            dateRegistered: this.dateRegistered,
            active: this.active,
            pending: this.pending,
            roles: this.roles,
            address: this.address,
            error: false,
          })
          .then((request) => {
            this.userDetailsSuccessful(request);
            this.$router.push("/admin/users/index");
          })
          .catch((err) => this.userDetailsFailed(err));
      } else {
        apiService
          .updateUser({
            id: this.id,
            companies: this.companies,
            customerId: this.customerId,
            firstName: this.firstName,
            lastName: this.lastName,
            title: this.title,
            email: this.email,
            phone: this.phone,
            dateRegistered: this.dateRegistered,
            active: this.active,
            pending: this.pending,
            roles: this.roles,
            address: this.address,
            error: false,
          })
          .then((request) => {
            this.userDetailsSuccessful(request);
            this.$router.push("/admin/users/index");
          })
          .catch((err) => this.userDetailsFailed(err));
      }
    },
    getUserTypes() {
      $("#userTypeSelect").dropdown("destroy");
      let _this = this;
      apiService
        .getUserTypes()
        .then((data) => {
          this.userTypes = data;
        })
        .then(() =>
          $("#userTypeSelect.ui.dropdown").dropdown({
            allowAdditions: true,
            onAdd: (addedValue) => {
              _this.addRoles(addedValue);
            },
            onRemove: (removedValue) => {
              _this.removeRoles(removedValue);
            },
          })
        );
    },
    getCompanies() {
      $("#companiesSelect").dropdown("destroy");
      let _this = this;
      apiService
        .getCompaniesList()
        .then((data) => {
          this.companyList = data;
        })
        .then(() => {
          $("#companiesSelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
            allowAdditions: true,
            onAdd: (addedValue) => {
              _this.addCompanies(addedValue);
            },
            onRemove: (removedValue) => {
              _this.removeCompanies(removedValue);
            },
          });
        });
    },
    onStateChange(event) {
      this.address.state = event.target.value;
    },
    onCountryChange(event) {
      this.address.country = event.target.value;
      this.getStates(this.address.country);
    },
    getStates(country) {
      var states = [];
      $("#stateSelect").dropdown("destroy");

      if (country == "") {
        country = "US";
      }
      apiService
        .getStatesByCountry(country)
        .then((data) => {
          for (var i = 0; i < data.length; i++) {
            var state = {
              key: data[i].code,
              value: data[i].code,
              flag: data[i].code.toLowerCase(),
              text: data[i].name,
            };
            states.push(state);
          }
          this.states = states;
        })
        .then(() => {
          $("#stateSelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        });
    },
    getCountries() {
      var countries = [];
      $("#countrySelect").dropdown("destroy");
      apiService
        .getCountries()
        .then((data) => {
          for (var i = 0; i < data.length; i++) {
            var country = {
              key: data[i].code,
              value: data[i].code,
              flag: data[i].code.toLowerCase(),
              text: data[i].name,
            };
            countries.push(country);
          }
          this.countries = countries;
        })
        .then(() => {
          $("#countrySelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
          $("#countrySelect").dropdown("set selected", this.address.country);
        });
    },
    addRoles(addedValue) {
      this.roles.push(addedValue);
    },
    removeRoles(removedValue) {
      var index = this.roles.indexOf(removedValue);

      if (index > -1) {
        this.roles.splice(index, 1);
      }
    },
    addCompanies(addedValue) {
      this.companies.push(addedValue);
    },
    removeCompanies(removedValue) {
      removedValue = parseInt(removedValue);

      var index = this.companies.indexOf(removedValue);

      if (index > -1) {
        this.companies.splice(index, 1);
      }
    },
  },
};
</script>

<style module></style>
